import React from 'react';
import { EMPTY_STATE_BODY, EMPTY_STATE_TITLE } from '../../utils/recompensePresentation';

/**
 * F2.2b — État vide + CTA création.
 */
export default function RecompenseEmptyState({ onAdd }) {
  return (
    <div
      className="rounded-lg border border-dashed border-gray-300 bg-gray-50 px-6 py-10 text-center space-y-4"
      data-testid="recompense-empty-state"
    >
      <p className="text-base font-medium text-gray-900">{EMPTY_STATE_TITLE}</p>
      <p className="text-sm text-gray-600 max-w-md mx-auto">{EMPTY_STATE_BODY}</p>
      {typeof onAdd === 'function' && (
        <button
          type="button"
          data-testid="recompense-add-empty"
          onClick={onAdd}
          className="px-4 py-2 rounded-lg text-sm font-medium bg-[#4A148C] text-white hover:bg-[#6A1B9A]"
        >
          Ajouter une récompense
        </button>
      )}
    </div>
  );
}
